import apiConfig from "../../apiConfig";

export const getAgentsList = async (at) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/AGENTS/GET_AGENTS_LIST",
		{},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response;
};
